import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var TrimPipe = (function () {
    function TrimPipe() {
    }
    TrimPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return input.trim();
    };
    return TrimPipe;
}());
export { TrimPipe };
TrimPipe.decorators = [
    { type: Pipe, args: [{
                name: 'trim'
            },] },
];
/** @nocollapse */
TrimPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=trim.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/trim.pipe.js
// module id = 293
// module chunks = 103